// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-history-message-diff span {
  white-space: pre-wrap;
  word-break: break-word;
}

.edit-history-message-row {
  padding: 12px 12px 0px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.edit-history-message-added {
  color: green;
  text-decoration: underline;
  background: #e6ffe6;
  border-radius: 2px;
  padding: 0 2px;
}

.edit-history-message-removed {
  color: red;
  text-decoration: line-through;
  background: #ffe6e6;
  border-radius: 2px;
  padding: 0 2px;
}

.edit-history-message-timestamp {
  padding-right: 12px;
  font-size: 12px;
  color: #888;
}
.edit-history-message-diff-wrap {
  overflow-wrap: anywhere;
  word-break: break-word;
  display: block;
  min-width: 0;
  flex-basis: 0;
  flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/RightSidebar/EditHistoryMessage.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,YAAY;AACd","sourcesContent":[".edit-history-message-diff span {\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.edit-history-message-row {\n  padding: 12px 12px 0px 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.edit-history-message-added {\n  color: green;\n  text-decoration: underline;\n  background: #e6ffe6;\n  border-radius: 2px;\n  padding: 0 2px;\n}\n\n.edit-history-message-removed {\n  color: red;\n  text-decoration: line-through;\n  background: #ffe6e6;\n  border-radius: 2px;\n  padding: 0 2px;\n}\n\n.edit-history-message-timestamp {\n  padding-right: 12px;\n  font-size: 12px;\n  color: #888;\n}\n.edit-history-message-diff-wrap {\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  display: block;\n  min-width: 0;\n  flex-basis: 0;\n  flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
